import React from "react";
import {
  Home,
  Send,
  ChevronDown,
  ChevronUp,
  Grid,
  Settings,
  Package,
} from "react-feather";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FUNCTIONALITIES } from "../../constants/functionalities";
import { addLog } from "../../services/logs";
import moment from "moment";

export function SidebarNav({ info, router: { location } }) {
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = React.useState(false);
  const [showExport, setShowExport] = React.useState(false);
  const [showImport, setShowImport] = React.useState(false);
  const [showImportDHL, setShowImportDHL] = React.useState(false);
  const [showImportTemu, setShowImportTemu] = React.useState(false);
  const [showAdmin, setShowAdmin] = React.useState(false);

  const adminRole =
    info.role.includes("ROLE_ADMIN") || info.role.includes("ROLE_OWNER");
  const ownerRole = info.role.includes("ROLE_OWNER");
  let pathname = location.pathname;

  const logOut = async () => {
    const data = {
      date: moment().format("YYYY-MM-DD HH:mm:ss"),
      action: "Logout",
      action_details: "Logged out",
      email: info.email,
      office: JSON.parse(localStorage.getItem("selected_office")).name,
    };

    var jsonData = JSON.stringify(data);

    await addLog(jsonData);

    localStorage.removeItem("token");
    navigate("/login");
  };

  const allowedFunctionalities = (functionalityParam) => {
    if (adminRole) return true;
    const functionality = localStorage.getItem("selected_office");
    if (functionality) {
      const functionalityList = JSON.parse(functionality).functionality;
      if (functionalityList.includes(functionalityParam)) {
        return true;
      }
    }
    return false;
  };

  const handleDropdown = (e) => {
    switch (e) {
      case "settings":
        setShowExport(false);
        setShowAdmin(false);
        break;
      case "export":
        setShowAdmin(false);
        setShowSettings(false);
        break;
      case "import":
        setShowAdmin(false);
        setShowSettings(false);
        break;
      case "admin":
        setShowExport(false);
        setShowSettings(false);
        break;
      default:
        break;
    }
  };

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner">
        <div id="sidebar-menu" className="sidebar-menu">
          <div style={{ marginBottom: 20, color: "rgba(35, 43, 53)" }}>
            Overview
          </div>
          <ul>
            <li>
              <Link to="/" style={{ textDecorationLine: "none" }}>
                <Home />{" "}
                <span
                  style={{
                    fontSize: "SeagoeUI",
                    marginLeft: 20,
                    cursor: "pointer",
                    fontFamily: pathname === "/" ? "SeagoeUIBold" : "SeagoeUI",
                  }}
                >
                  Dashboard
                </span>
              </Link>
            </li>
            {ownerRole && (
              <li>
                <a onClick={() => setShowAdmin(!showAdmin)}>
                  <Grid />{" "}
                  <span
                    style={{
                      fontSize: "SeagoeUI",
                      marginLeft: 20,
                      cursor: "pointer",
                    }}
                  >
                    Admin
                  </span>
                  {showAdmin ? (
                    <ChevronUp className="chevron" />
                  ) : (
                    <ChevronDown className="chevron" />
                  )}
                </a>

                <ul
                  className={
                    showAdmin ? "sidebar-dropdown show" : "sidebar-dropdown  "
                  }
                >
                  <li>
                    <Link
                      to="/user"
                      style={{
                        textDecorationLine: "none",
                        paddingLeft: 60,
                        fontFamily: pathname.includes("/user")
                          ? "SeagoeUIBold"
                          : "SeagoeUI",
                      }}
                      onClick={() => handleDropdown("admin")}
                    >
                      User
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/office"
                      style={{
                        textDecorationLine: "none",
                        paddingLeft: 60,
                        fontFamily: pathname.includes("/office")
                          ? "SeagoeUIBold"
                          : "SeagoeUI",
                      }}
                      onClick={() => handleDropdown("admin")}
                    >
                      Office
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {allowedFunctionalities(FUNCTIONALITIES.exportDailyReport) && (
              <li>
                <a onClick={() => setShowExport(!showExport)}>
                  <Send />{" "}
                  <span style={{ fontSize: "SeagoeUI", marginLeft: 20 }}>
                    Export
                  </span>
                  {showExport ? (
                    <ChevronUp className="chevron" />
                  ) : (
                    <ChevronDown className="chevron" />
                  )}
                </a>

                <ul
                  className={
                    showExport ? "sidebar-dropdown show" : "sidebar-dropdown"
                  }
                >
                  <li>
                    <Link
                      to="/reporting_r2_export"
                      style={{
                        textDecorationLine: "none",
                        paddingLeft: 60,
                        fontFamily:
                          pathname === "/reporting_r2_export"
                            ? "SeagoeUIBold"
                            : "SeagoeUI",
                      }}
                      onClick={() => handleDropdown("export")}
                    >
                      Reporting R2
                    </Link>
                  </li>

                  {allowedFunctionalities(FUNCTIONALITIES.createExport) && (
                    <li>
                      <Link
                        to="/create_export"
                        style={{
                          textDecorationLine: "none",
                          paddingLeft: 60,
                          fontFamily:
                            pathname === "/create_export"
                              ? "SeagoeUIBold"
                              : "SeagoeUI",
                        }}
                        onClick={() => handleDropdown("export")}
                      >
                        Create Declaration
                      </Link>
                    </li>
                  )}

                  {allowedFunctionalities(FUNCTIONALITIES.exportMazda) && (
                    <li>
                      <Link
                        to="/mazda_export"
                        style={{
                          textDecorationLine: "none",
                          paddingLeft: 60,
                          fontFamily:
                            pathname === "/mazda_export"
                              ? "SeagoeUIBold"
                              : "SeagoeUI",
                        }}
                        onClick={() => handleDropdown("export")}
                      >
                        Mazda Declaration
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {allowedFunctionalities(FUNCTIONALITIES.createImport) && (
              <li>
                <a onClick={() => setShowImport(!showImport)}>
                  <Package />{" "}
                  <span style={{ fontSize: "SeagoeUI", marginLeft: 20 }}>
                    Import
                  </span>
                  {showImport ? (
                    <ChevronUp className="chevron" />
                  ) : (
                    <ChevronDown className="chevron" />
                  )}
                </a>

                {/* H7 sub-section */}
                {showImport &&
                  allowedFunctionalities(FUNCTIONALITIES.createImport) && (
                    <ul
                      className="sidebar-dropdown show"
                      style={{ paddingLeft: 0 }}
                    >
                      <li>
                        <a
                          onClick={() => setShowImportDHL(!showImportDHL)}
                          style={{ paddingLeft: 40, cursor: "pointer" }}
                        >
                          <span style={{ fontFamily: "SeagoeUI" }}>H7</span>
                          {showImportDHL ? (
                            <ChevronUp className="chevron" />
                          ) : (
                            <ChevronDown className="chevron" />
                          )}
                        </a>
                        {showImportDHL && (
                          <ul className="sidebar-dropdown show">
                            <li>
                              <Link
                                to="/create_import"
                                style={{
                                  textDecorationLine: "none",
                                  paddingLeft: 60,
                                  fontFamily:
                                    pathname === "/create_import"
                                      ? "SeagoeUIBold"
                                      : "SeagoeUI",
                                }}
                                onClick={() => handleDropdown("import")}
                              >
                                H1 Import
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/create_import_h7"
                                style={{
                                  textDecorationLine: "none",
                                  paddingLeft: 60,
                                  fontFamily:
                                    pathname === "/create_import_h7"
                                      ? "SeagoeUIBold"
                                      : "SeagoeUI",
                                }}
                                onClick={() => handleDropdown("import")}
                              >
                                H7 Import
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/sold_import"
                                style={{
                                  textDecorationLine: "none",
                                  paddingLeft: 60,
                                  fontFamily:
                                    pathname === "/sold_import"
                                      ? "SeagoeUIBold"
                                      : "SeagoeUI",
                                }}
                                onClick={() => handleDropdown("import")}
                              >
                                Sold Import
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>

                      {/* E-commerce sub-section */}
                      <li>
                        <a
                          onClick={() => setShowImportTemu(!showImportTemu)}
                          style={{ paddingLeft: 40, cursor: "pointer" }}
                        >
                          <span style={{ fontFamily: "SeagoeUI" }}>
                            E-commerce
                          </span>
                          {showImportTemu ? (
                            <ChevronUp className="chevron" />
                          ) : (
                            <ChevronDown className="chevron" />
                          )}
                        </a>
                        {showImportTemu && (
                          <ul className="sidebar-dropdown show">
                            <li>
                              <Link
                                to="/temu_import"
                                style={{
                                  textDecorationLine: "none",
                                  paddingLeft: 60,
                                  fontFamily:
                                    pathname === "/temu_import"
                                      ? "SeagoeUIBold"
                                      : "SeagoeUI",
                                }}
                                onClick={() => handleDropdown("import")}
                              >
                                H1 Import
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/temu_import_h7"
                                style={{
                                  textDecorationLine: "none",
                                  paddingLeft: 60,
                                  fontFamily:
                                    pathname === "/temu_import_h7"
                                      ? "SeagoeUIBold"
                                      : "SeagoeUI",
                                }}
                                onClick={() => handleDropdown("import")}
                              >
                                H7 Import
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    </ul>
                  )}
                <ul
                  className={
                    showImport ? "sidebar-dropdown show" : "sidebar-dropdown"
                  }
                >
                  {allowedFunctionalities(FUNCTIONALITIES.createImport) && (
                    <li>
                      <Link
                        to="/import/CBAM"
                        style={{
                          textDecorationLine: "none",
                          paddingLeft: 60,
                          fontFamily:
                            pathname === "/import/CBAM"
                              ? "SeagoeUIBold"
                              : "SeagoeUI",
                        }}
                        onClick={() => handleDropdown("import")}
                      >
                        CBAM
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {(adminRole ||
              allowedFunctionalities(FUNCTIONALITIES.profileOffice) ||
              allowedFunctionalities(FUNCTIONALITIES.templates)) && (
              <li>
                <a onClick={() => setShowSettings(!showSettings)}>
                  <Settings />{" "}
                  <span style={{ fontSize: "SeagoeUI", marginLeft: 20 }}>
                    Settings
                  </span>
                  {showSettings ? (
                    <ChevronUp className="chevron" />
                  ) : (
                    <ChevronDown className="chevron" />
                  )}
                </a>

                <ul
                  className={
                    showSettings ? "sidebar-dropdown show" : "sidebar-dropdown"
                  }
                >
                  {allowedFunctionalities(FUNCTIONALITIES.profileOffice) && (
                    <li>
                      <Link
                        to="/profile"
                        style={{
                          textDecorationLine: "none",
                          paddingLeft: 60,
                          fontFamily:
                            pathname === "/profile"
                              ? "SeagoeUIBold"
                              : "SeagoeUI",
                        }}
                        onClick={() => handleDropdown("settings")}
                      >
                        Profile
                      </Link>
                    </li>
                  )}
                  {adminRole && (
                    <li>
                      <Link
                        to="/logs"
                        style={{
                          textDecorationLine: "none",
                          paddingLeft: 60,
                          fontFamily:
                            pathname === "/logs" ? "SeagoeUIBold" : "SeagoeUI",
                        }}
                        onClick={() => handleDropdown("settings")}
                      >
                        Logs
                      </Link>
                    </li>
                  )}
                  {allowedFunctionalities(FUNCTIONALITIES.templates) && (
                    <li>
                      <Link
                        to="/templates"
                        style={{
                          textDecorationLine: "none",
                          paddingLeft: 60,
                          fontFamily: pathname.includes("/template")
                            ? "SeagoeUIBold"
                            : "SeagoeUI",
                        }}
                        onClick={() => handleDropdown("settings")}
                      >
                        Templates
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
          </ul>
        </div>
        <div className="overview-sidebar">
          <div className="avatar-sidebar">
            <div className="avatar-top-right">
              <p className="role-sidebar">{info.company_name}</p>
            </div>
            <img
              src={info.photo}
              alt={""}
              width={44}
              height={44}
              style={{ borderRadius: "50%" }}
            />
          </div>
          <p className="name-sidebar">{info.name}</p>
          <p className="email-sidebar">{info.email}</p>
          <div className="button-sidebar" onClick={logOut}>
            <p
              style={{
                color: "#fff",
                fontFamily: "SeagoeUIBold",
                fontSize: "0.8rem",
              }}
            >
              Log out
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

export default withRouter(SidebarNav);
